import { render, staticRenderFns } from "./DuelsUserElement.vue?vue&type=template&id=6ba30a44&scoped=true"
import script from "./DuelsUserElement.vue?vue&type=script&lang=js"
export * from "./DuelsUserElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsUserElement.vue?vue&type=style&index=0&id=6ba30a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba30a44",
  null
  
)

export default component.exports